import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "recenter"
const RecenterIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path d="M15.53 18.97 14.47 20.03 12.75 18.31V22.5H11.25V18.31L9.53 20.03 8.47 18.97 12 15.44zM8.56 12 5.03 15.53 3.97 14.47 5.69 12.75H1.5V11.25H5.69L3.97 9.53 5.03 8.47zM20.03 9.53 18.31 11.25H22.5V12.75H18.31L20.03 14.47 18.97 15.53 15.44 12 18.97 8.47z" />
          <path
            fillRule="evenodd"
            d="M12 9.375C13.45 9.375 14.625 10.55 14.625 12S13.45 14.625 12 14.625 9.375 13.45 9.375 12 10.55 9.375 12 9.375M12 10.875C11.379 10.875 10.875 11.379 10.875 12S11.379 13.125 12 13.125 13.125 12.621 13.125 12 12.621 10.875 12 10.875"
            clipRule="evenodd"
          />
          <path d="M12.75 5.69 14.47 3.97 15.53 5.03 12 8.56 8.47 5.03 9.53 3.97 11.25 5.69V1.5H12.75z" />
        </svg>
      }
    </span>
  )
}
export default RecenterIcon
